import React from "react";
import PropTypes from "prop-types";
import TableSectionContext from "./Table/TableSectionContext";

/** Represents a block of rows that consist of a body of data for the table. */
import { jsx as _jsx } from "react/jsx-runtime";
export default function TBody(_ref) {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx("tbody", {
    ...props,
    children: /*#__PURE__*/_jsx(TableSectionContext.Provider, {
      value: "tbody",
      children: children
    })
  });
}
TBody.propTypes = {
  /** The table body rows. */
  children: PropTypes.node
};